import { siteConfig } from "../config/siteConfig";
import apiCall from "../utils/apiCall";

export const getContactDetails = async () => {
  try {
    const response = await apiCall("/contact", "GET");
    if (!response.ok) {
      return siteConfig;
    }

    const payload = await response.json();
    return payload?.data ?? payload ?? siteConfig;
  } catch {
    return siteConfig;
  }
};

export default getContactDetails;
